<template>
  <div>
    <a @click="scrollTop">
      <img class="sd-arrow-top"
        src="/static/material_icons/arrow_upward.png"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'sd-arrow-top',

  methods: {
    scrollTop() {
      const anchor = this.$parent.$el.querySelector('.sd-anchor-top');
      anchor && anchor.scrollIntoView();
      window.scrollBy(0, -160);
    },
  },
};
</script>

<style lang="scss">
@import "./../Globals.scss";

.sd-arrow-top {
  cursor: pointer;
  position: fixed;
  font-size: 60px;
  bottom: 20px;
  right: 20px;
  background: $sd-color-blue;
  box-shadow: 0 5px 5px 0  rgba(0, 0, 0, 0.2);

  &:hover {
    opacity: 0.8;
  }
}

@media (max-width: 1100px) {
  .sd-arrow-top {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// ArrowTop.vue?4daeabfb